<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/sSjZif/tc-custom/9780830873739.jpg?1696024724303" alt="This image is the cover for the book Praying for Your Missionary"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Praying for Your Missionary
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>Being a missionary is a noble calling, but it's also a difficult one.</strong> Missionaries face many challenges, whether adjusting to a new culture, learning a new language, or guarding against spiritual attacks. They need the support of the church and a faithful covering of prayer. But for many Christians, missionaries are out of sight, out of mind. How can we effectively intercede for the missionaries in our lives? Eddie Byun provides a handy guide to praying for missionaries. He shows the vital connection between prayer and missions, how our prayers are connected to both the well-being of missionaries and the fruit of their work. This book offers ways to pray for the various needs that missionaries have on the mission field, to prevent burnout and protect them from harm. We can partner with our missionaries as individual intercessors and as sending churches. The fields are ready for harvest. Your prayers for the workers and their ministry can make a difference.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Eddie Byun
      </h2>
      
      <p class="authorDescription body article"><p>Eddie Byun is the missions and teaching pastor of Venture Christian Church in Los Gatos, California. He has previously taught practical theology at Torch Trinity Graduate University and has been lead pastor for Crossway Mission Church and Onnuri English Ministry in Seoul, South Korea. He has also pastored in Sydney, Australia, and Vancouver, Canada. Eddie is the author of <em>Justice Awakening</em> and <em>Praying for Your Pastor</em>. He was also the executive producer of <em>Save My Seoul</em>, an award-winning documentary on sex trafficking in South Korea. He resides in San Jose, California, with his wife, Hyun, and their son.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1fba75ac